import React from 'react';
import { Badge, Card, Divider, Grid, Group, NumberInput, Text, ThemeIcon } from '@mantine/core';
import { IconTrendingUp } from '@tabler/icons-react';
import type { IVariablesPostventa } from '../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';

interface FormularioVariablesPostventaVistaProps {
    variables: IVariablesPostventa;
    alCambiar: (campo: keyof IVariablesPostventa, valor: number | string) => void;
}

/** Valores por defecto de cada cotización nueva. */
export const FormularioVariablesPostventaVista: React.FC<FormularioVariablesPostventaVistaProps> = ({ variables, alCambiar }) => {
    const vacio = (campo: keyof IVariablesPostventa) => String(variables[campo] ?? '') === '';

    return (
        <Grid gutter="lg">
            <Grid.Col span={{ base: 12, md: 6 }}>
                <Card shadow="none" p="lg" radius="md" withBorder h="100%">
                    <Group justify="space-between" mb="xs">
                        <Group gap="xs">
                            <ThemeIcon variant="light" color="primary" radius="xl" size="md"><IconTrendingUp size={18} /></ThemeIcon>
                            <Text fw={600} size="lg">Valores por Defecto</Text>
                        </Group>
                        <Badge color="primary" variant="light" radius="xl" style={{ textTransform: 'none' }}>Cotización nueva</Badge>
                    </Group>
                    <Divider mb="md" />
                    <Grid>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <NumberInput
                                size="xs" withAsterisk min={0} allowNegative={false} hideControls decimalScale={3}
                                label="Factor precio"
                                description="Multiplicador sobre el costo directo"
                                value={variables.FactorPrecio}
                                onChange={(v) => alCambiar('FactorPrecio', v)}
                                error={vacio('FactorPrecio')}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <NumberInput
                                size="xs" withAsterisk min={0} allowNegative={false} hideControls
                                label="Tarifa hora hombre"
                                description="Incluye prestaciones"
                                prefix="$ " suffix=" COP" thousandSeparator="." decimalSeparator=","
                                value={variables.TarifaHoraHombre}
                                onChange={(v) => alCambiar('TarifaHoraHombre', v)}
                                error={vacio('TarifaHoraHombre')}
                            />
                        </Grid.Col>
                    </Grid>
                    <Text size="xs" c="dimmed" mt="md">Cada cotización nueva arranca con estos valores; el comercial los puede ajustar en la cotización.</Text>
                </Card>
            </Grid.Col>
        </Grid>
    );
};
